import api from "@/api";
import {edition} from '@/common/config'


//故障 - 故障检索
export const rekeyword = (data) => {
 
 return api.axss("post", `/ocm-gdb/failure/wechat/retrieval/keyword`, data)
}

//故障 - 优化的故障检索故障检索
export const newrekeyword = (data) => {

  return api.axss("post", `/ocm-gdb/failure/super/retrieval/keyword/supre`, data)
 }

//故障 - 下拉关键字查询
export const pullcheck = () => {
  if(edition==1){
    return 
  }
  return api.axss("get", `/ocm-gdb/failure/search/failure/pullcheck`)
}

//故障 - 详情
export const failureInfo = (id) => {
  return api.axss("get", `/ocm-gdb/failure/detail/failureInfo?failureId=${id}`)
}

//故障 - 详情
export const getSearch = (data) => {
  return api.axss("post", `/ocm-search/search/getSearch`,data)
}
